import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    this.#modal = new bootstrap.Modal(this.element)
    this.element.addEventListener("hidden.bs.modal", this.#cleanup)
    this.#modal.show()
  }

  disconnect() {
    this.#modal?.dispose()
  }

  #cleanup = () => {
    this.element.remove()
  }

  #modal = null
}
